import PropTypes from 'prop-types';
import { Lock } from '@mui/icons-material';
import { Box } from '@mui/material';
import Offcanvas from 'react-bootstrap/Offcanvas';
import classNames from 'classnames';
import UI from '../../constants/ui';
import URL from '../../constants/urls';
import styles from './navigationComponent.module.css';
import useGAEventsTracker from '../../hooks/useGAEventsTracker';
import GA from '../../constants/analytics.constants';
import { IMAGE_URL } from '../../constants/apiUrls';
import NewTag from '../../components/newTag/NewTag';
import { SMALL_MOBILE_SCREEN_WIDTH } from '../../constants/screenSize';
import LOGIN_TYPE from '../../constants/loginType';
import { getLoginDetailFromSession } from '../../helpers/sessionDetails';
import ServicesDropdown from './ServiceDropdown';

const KEBAB_LINK = `color-1F2830 ${styles.navLink} px-3 py-1 w-100 subtitle-1`;
const ACTIVE_KEBAB_LINK = styles.activeKebabLink;
const MENU_ITEM_STYLE = styles.menuitem;

function RenderMenu(props) {
  const GAEventsTracker = useGAEventsTracker(GA.EVENT_BUTTON.NAVIGATION);

  const {
    shouldOpen,
    setShouldOpen,
    isMobileDevice,
    activeUrl,
    loggedInUserRole,
    handleLogout,
    onSelectNavOption,
    hasUpdateJobPermission,
    project,
    isApprovalPending,
    notificationCount,
    windowWidth,
  } = props;

  return (
    <Offcanvas
      show={shouldOpen}
      onHide={() => {
        setShouldOpen(!shouldOpen);
      }}
      placement={isMobileDevice ? 'start' : 'end'}
    >
      <Offcanvas.Header closeButton className="py-4">
        <Offcanvas.Title>
          <img
            src={IMAGE_URL.ALIGNMYCAREER}
            alt={UI.ALT_ALIGNMYCAREER}
            loading="lazy"
            title={UI.ALT_ALIGNMYCAREER}
            width="200px"
            height="100%"
          />
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="pb-4">
        {loggedInUserRole === LOGIN_TYPE.EMPLOYER ? (
          <div>
            <div className="px-3 py-2 w-100 text-primary">
              <span className="px-3">{getLoginDetailFromSession()?.name}</span>
            </div>

            <hr className="mt-1 mb-1" />
            {isMobileDevice && (
              <>
                {/* {(loggedInUserRole === LOGIN_TYPE.EMPLOYER ||
                    !loggedInUserRole) && (
                      <div
                        onClick={onClickAIQuestionForm}
                        className={classNames(MENU_ITEM_STYLE)}
                      >
                        <span
                          style={{ color: '#0d6efd', cursor: 'pointer' }}
                          className="px-3"
                        >
                          {UI.TRY_AI_ASSESSOR}
                        </span>
                      </div>
                    )} */}

                <hr className="mt-1 mb-1" />
                <div
                  onClick={() => onSelectNavOption(URL.FIND_CANDIDATES)}
                  className={classNames(MENU_ITEM_STYLE)}
                >
                  <div
                    className={classNames(KEBAB_LINK, {
                      [ACTIVE_KEBAB_LINK]: activeUrl === URL.FIND_CANDIDATES,
                    })}
                  >
                    {UI.FIND_TALENT}
                  </div>
                </div>
                <hr className="my-2" />
              </>
            )}
            <div
              onClick={() => onSelectNavOption(URL.COMPANY_EMPLOYEE_PROFILE)}
              className={classNames(MENU_ITEM_STYLE)}
            >
              <div
                to={URL.COMPANY_EMPLOYEE_PROFILE}
                className={classNames(KEBAB_LINK, {
                  [ACTIVE_KEBAB_LINK]:
                    activeUrl === URL.COMPANY_EMPLOYEE_PROFILE,
                })}
              >
                {UI.PROFILE}
              </div>
            </div>
            <div
              onClick={() => onSelectNavOption(URL.EMPLOYER_PROFILE)}
              className={classNames(MENU_ITEM_STYLE)}
            >
              <div
                to={URL.EMPLOYER_PROFILE}
                className={classNames(KEBAB_LINK, {
                  [ACTIVE_KEBAB_LINK]: activeUrl === URL.EMPLOYER_PROFILE,
                })}
              >
                {UI.COMPANY_PROFILE}
              </div>
            </div>

            <div
              onClick={() => onSelectNavOption(URL.POST_JOB)}
              className={classNames(MENU_ITEM_STYLE)}
              disabled={!hasUpdateJobPermission}
            >
              <div
                to={URL.POST_JOB}
                className={classNames(KEBAB_LINK, {
                  [ACTIVE_KEBAB_LINK]: activeUrl === URL.POST_JOB,
                })}
                onClick={() => GAEventsTracker(UI.POST_JOB)}
              >
                <div className="d-flex justify-content-between">
                  {UI.POST_JOB}
                  {!hasUpdateJobPermission && (
                    <Lock sx={{ height: '1.2rem' }} />
                  )}
                </div>
              </div>
            </div>
            <div
              onClick={() => onSelectNavOption(URL.POSTED_JOBS)}
              className={classNames(MENU_ITEM_STYLE)}
              disabled={!project || isApprovalPending}
            >
              <div
                to={URL.POSTED_JOBS}
                className={classNames(KEBAB_LINK, {
                  [ACTIVE_KEBAB_LINK]: activeUrl === URL.POSTED_JOBS,
                })}
                onClick={() => GAEventsTracker(UI.POSTED_JOB)}
              >
                <div className="d-flex justify-content-between">
                  {UI.POSTED_JOB}
                  {(!project || isApprovalPending) && (
                    <Lock sx={{ height: '1.2rem' }} />
                  )}
                </div>
              </div>
            </div>

            <div
              onClick={() => onSelectNavOption(URL.MY_CANDIDATES)}
              className={classNames(MENU_ITEM_STYLE)}
              disabled={!project || isApprovalPending}
            >
              <div
                to={URL.MY_CANDIDATES}
                className={classNames(KEBAB_LINK, {
                  [ACTIVE_KEBAB_LINK]: activeUrl === URL.MY_CANDIDATES,
                })}
                onClick={() => GAEventsTracker(UI.MY_CANDIDATES)}
              >
                <div className="d-flex justify-content-between">
                  {UI.MY_CANDIDATES}
                  {(!project || isApprovalPending) && (
                    <Lock sx={{ height: '1.2rem' }} />
                  )}
                </div>
              </div>
            </div>
            <div
              onClick={() => onSelectNavOption(URL.INVITE_CANDIDATES)}
              className={classNames(MENU_ITEM_STYLE)}
              disabled={!project || isApprovalPending}
            >
              <div
                to={URL.INVITE_CANDIDATES}
                className={classNames(KEBAB_LINK, {
                  [ACTIVE_KEBAB_LINK]: activeUrl === URL.INVITE_CANDIDATES,
                })}
                onClick={() => GAEventsTracker(UI.TITLE_INVITE_CANDIDATES)}
              >
                <div className="d-flex justify-content-between">
                  {UI.TITLE_INVITE_CANDIDATES}
                  {(!project || isApprovalPending) && (
                    <Lock sx={{ height: '1.2rem' }} />
                  )}
                </div>
              </div>
            </div>

            {/* have to change the disabled logic depending on permissions */}
            <div
              onClick={() => onSelectNavOption(URL.EMPLOYER_ASSESSMENTS)}
              className={classNames(MENU_ITEM_STYLE)}
              disabled={!project || isApprovalPending}
            >
              <div
                to={URL.EMPLOYER_ASSESSMENTS}
                className={classNames(KEBAB_LINK, {
                  [ACTIVE_KEBAB_LINK]: activeUrl === URL.EMPLOYER_ASSESSMENTS,
                })}
              >
                <div className="d-flex justify-content-between">
                  {UI.ASSESSMENTS}
                  {(!project || isApprovalPending) && (
                    <Lock sx={{ height: '1.2rem' }} />
                  )}
                </div>
              </div>
            </div>
            <div
              onClick={() => onSelectNavOption(URL.AI_INTERVIEW)}
              className={classNames(MENU_ITEM_STYLE)}
              disabled={!project || isApprovalPending}
            >
              <div
                to={URL.AI_INTERVIEW}
                className={classNames(KEBAB_LINK, {
                  [ACTIVE_KEBAB_LINK]: activeUrl === URL.AI_INTERVIEW,
                })}
              >
                <div className="d-flex justify-content-between">
                  {UI.AI_INTERVIEW_NAVBAR}
                  {(!project || isApprovalPending) && (
                    <Lock sx={{ height: '1.2rem' }} />
                  )}
                </div>
              </div>
            </div>
            <div
              onClick={() => onSelectNavOption(URL.EVENTS)}
              className={classNames(MENU_ITEM_STYLE)}
              disabled={!project || isApprovalPending}
            >
              <div
                to={URL.EVENTS}
                className={classNames(KEBAB_LINK, {
                  [ACTIVE_KEBAB_LINK]: activeUrl === URL.EVENTS,
                })}
              >
                <div className="d-flex justify-content-between">
                  {UI.EVENTS}
                  {(!project || isApprovalPending) && (
                    <Lock sx={{ height: '1.2rem' }} />
                  )}
                </div>
              </div>
            </div>

            <div
              onClick={() => onSelectNavOption(URL.PROJECT_DETAILS)}
              className={classNames(MENU_ITEM_STYLE)}
              disabled={!project || isApprovalPending}
            >
              <div
                to={URL.PROJECT_DETAILS}
                className={classNames(KEBAB_LINK, {
                  [ACTIVE_KEBAB_LINK]: activeUrl === URL.PROJECT_DETAILS,
                })}
              >
                <div className="d-flex justify-content-between">
                  {UI.PROJECT_DETAILS}
                  {(!project || isApprovalPending) && (
                    <Lock sx={{ height: '1.2rem' }} />
                  )}
                </div>
              </div>
            </div>
            <div
              onClick={() => onSelectNavOption(URL.MY_PROJECTS)}
              className={classNames(MENU_ITEM_STYLE)}
            >
              <div
                to={URL.MY_PROJECTS}
                className={classNames(KEBAB_LINK, {
                  [ACTIVE_KEBAB_LINK]: activeUrl === URL.MY_PROJECTS,
                })}
              >
                {UI.MY_PROJECTS}
              </div>
            </div>
            <div
              onClick={() => onSelectNavOption(URL.COMPANY_PROJECTS)}
              className={classNames(MENU_ITEM_STYLE)}
            >
              <div
                to={URL.COMPANY_PROJECTS}
                className={classNames(KEBAB_LINK, {
                  [ACTIVE_KEBAB_LINK]: activeUrl === URL.COMPANY_PROJECTS,
                })}
              >
                {UI.COMPANY_PROJECTS}
              </div>
            </div>
          </div>
        ) : null}

        {loggedInUserRole === LOGIN_TYPE.CANDIDATE ? (
          <div>
            <div className="px-3 py-2 w-100 text-primary">
              {getLoginDetailFromSession()?.name}
            </div>

            <hr className="mt-1 mb-1" />
            {isMobileDevice && (
              <div>
                <div
                  onClick={() => onSelectNavOption(URL.FIND_JOBS)}
                  className={classNames(MENU_ITEM_STYLE)}
                >
                  <div
                    to={URL.FIND_JOBS}
                    className={classNames(KEBAB_LINK, {
                      [ACTIVE_KEBAB_LINK]: activeUrl === URL.FIND_JOBS,
                    })}
                  >
                    {UI.FIND_JOBS}
                  </div>
                </div>
                <hr className="mt-1 mb-1" />
              </div>
            )}

            <div
              onClick={() => onSelectNavOption(URL.CANDIDATE_PROFILE)}
              className={classNames(MENU_ITEM_STYLE)}
            >
              <div
                to={URL.CANDIDATE_PROFILE}
                className={classNames(KEBAB_LINK, {
                  [ACTIVE_KEBAB_LINK]: activeUrl === URL.CANDIDATE_PROFILE,
                })}
              >
                {UI.PROFILE}
              </div>
            </div>
            <div
              onClick={() => onSelectNavOption(URL.MY_JOBS)}
              className={classNames(MENU_ITEM_STYLE)}
            >
              <div
                to={URL.MY_JOBS}
                className={classNames(KEBAB_LINK, {
                  [ACTIVE_KEBAB_LINK]: activeUrl === URL.MY_JOBS,
                })}
                onClick={() => GAEventsTracker(UI.MY_JOBS)}
              >
                {UI.MY_JOBS}
              </div>
            </div>
            <div
              onClick={() => onSelectNavOption(URL.My_Profile_Activity)}
              className={classNames(MENU_ITEM_STYLE)}
            >
              <div
                to={URL.My_Profile_Activity}
                className={classNames(KEBAB_LINK, {
                  [ACTIVE_KEBAB_LINK]: activeUrl === URL.My_Profile_Activity,
                })}
                onClick={() => GAEventsTracker(UI.MY_PROFILE_ACTIVITY)}
              >
                {UI.MY_PROFILE_ACTIVITY}
              </div>
            </div>

            <div
              onClick={() => onSelectNavOption(URL.ASSESSMENT)}
              className={classNames(MENU_ITEM_STYLE)}
            >
              <div
                to={URL.ASSESSMENT}
                className={classNames(KEBAB_LINK, {
                  [ACTIVE_KEBAB_LINK]: activeUrl === URL.ASSESSMENT,
                })}
                onClick={() => GAEventsTracker(UI.ASSESSMENT)}
              >
                {UI.ASSESSMENT}
              </div>
            </div>

            <div
              onClick={() => onSelectNavOption(URL.RECOMMENDATIONS)}
              className={classNames(MENU_ITEM_STYLE)}
            >
              <div
                className={classNames(KEBAB_LINK, {
                  [ACTIVE_KEBAB_LINK]: activeUrl === URL.RECOMMENDATIONS,
                })}
              >
                {UI.RECOMMENDATIONS}
              </div>
            </div>

            <div
              onClick={() => onSelectNavOption(URL.MOCK_INTERVIEW)}
              className={classNames(MENU_ITEM_STYLE)}
            >
              <div
                to={URL.MOCK_INTERVIEW}
                className={classNames(KEBAB_LINK, {
                  [ACTIVE_KEBAB_LINK]: activeUrl === URL.MOCK_INTERVIEW,
                })}
              >
                {UI.MOCK_INTERVIEW}
              </div>
            </div>
            <div
              onClick={() => onSelectNavOption(URL.CAREER_PATH)}
              className={classNames(MENU_ITEM_STYLE)}
            >
              <div
                to={URL.CAREER_PATH}
                className={classNames(KEBAB_LINK, {
                  [ACTIVE_KEBAB_LINK]: activeUrl === URL.CAREER_PATH,
                })}
              >
                {UI.MY_CAREER_PATH}
              </div>
            </div>
            <div
              onClick={() => onSelectNavOption(URL.CANDIDATE_CERTIFICATES)}
              className={classNames(MENU_ITEM_STYLE)}
            >
              <div
                to={URL.CANDIDATE_CERTIFICATES}
                className={classNames(KEBAB_LINK, {
                  [ACTIVE_KEBAB_LINK]: activeUrl === URL.CANDIDATE_CERTIFICATES,
                })}
              >
                {UI.MY_CERTIFICATES}
              </div>
            </div>
            <div
              onClick={() => onSelectNavOption(URL.EVENTS)}
              className={classNames(MENU_ITEM_STYLE)}
            >
              <div
                to={URL.EVENTS}
                className={classNames(KEBAB_LINK, {
                  [ACTIVE_KEBAB_LINK]: activeUrl === URL.EVENTS,
                })}
                onClick={() => GAEventsTracker(UI.EVENTS)}
              >
                {UI.EVENTS}
              </div>
            </div>
          </div>
        ) : null}
        {windowWidth < SMALL_MOBILE_SCREEN_WIDTH && (
          <div>
            <div
              onClick={() => onSelectNavOption(URL.NOTIFICATIONS)}
              className={classNames(MENU_ITEM_STYLE)}
            >
              <div
                to={URL.NOTIFICATIONS}
                className={classNames(KEBAB_LINK, {
                  [ACTIVE_KEBAB_LINK]: activeUrl === URL.NOTIFICATIONS,
                })}
              >
                <div className="d-flex align-items-center">
                  <div>{UI.NOTIFICATIONS}</div>
                  {notificationCount > 0 &&
                    windowWidth < SMALL_MOBILE_SCREEN_WIDTH && (
                      <div
                        style={{
                          borderRadius: '50%',
                          backgroundColor: 'red',
                          color: 'white',
                          width: '20px',
                          height: '20px',
                          textAlign: 'center',
                        }}
                        className="ms-1"
                      >
                        {notificationCount}
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>
        )}
        {isMobileDevice && (
          <div
            onClick={() => onSelectNavOption(URL.BLOG_PAGE)}
            className={classNames(MENU_ITEM_STYLE)}
          >
            <div
              to={URL.BLOG_PAGE}
              className={classNames(KEBAB_LINK, {
                [ACTIVE_KEBAB_LINK]: activeUrl === URL.BLOG_PAGE,
              })}
            >
              {UI.BLOG_PAGE}
              <span
                style={{
                  marginLeft: '4px',
                }}
              >
                <NewTag paddingValue={4} />
              </span>
            </div>
          </div>
        )}
        {loggedInUserRole === LOGIN_TYPE.UNIVERSITY ||
          (loggedInUserRole === LOGIN_TYPE.ADMIN && (
            <div className="px-3 py-2 w-100 text-primary">
              {getLoginDetailFromSession()?.name}
            </div>
          ))}

        {loggedInUserRole ? (
          <div>
            {/* {(loggedInUserRole === LOGIN_TYPE.EMPLOYER ||
                loggedInUserRole === LOGIN_TYPE.CANDIDATE) && (
                <div
                  onClick={() => onSelectNavOption(URL.OFFERS)}
                  className={classNames(MENU_ITEM_STYLE)}
                >
                  <div
                    to={URL.OFFERS}
                    className={classNames(KEBAB_LINK, {
                      [ACTIVE_KEBAB_LINK]: activeUrl === URL.OFFERS,
                    })}
                    onClick={() => GAEventsTracker(UI.OFFERS)}
                  >
                    {UI.OFFERS}
                  </div>
                </div>
              )} */}
            <div
              onClick={() => onSelectNavOption(URL.SETTING)}
              className={classNames(MENU_ITEM_STYLE)}
            >
              <div
                to={URL.SETTING}
                className={classNames(KEBAB_LINK, {
                  [ACTIVE_KEBAB_LINK]: activeUrl === URL.SETTING,
                })}
              >
                {UI.SETTING}
              </div>
            </div>

            {windowWidth < SMALL_MOBILE_SCREEN_WIDTH && (
              <>
                {/* Services Dropdown */}
                <ServicesDropdown
                  onSelectNavOption={onSelectNavOption}
                  KEBAB_LINK={KEBAB_LINK}
                />
              </>
            )}

            <hr className="mt-1 mb-1" />
            <div onClick={handleLogout} className={classNames(MENU_ITEM_STYLE)}>
              <div className="px-3 py-1 w-100 color-F25C05 cursor-pointer">
                {UI.LOGOUT}
              </div>
            </div>
          </div>
        ) : (
          <div>
            {isMobileDevice && (
              <Box>
                <div
                  onClick={() => onSelectNavOption(URL.FIND_JOBS)}
                  className={classNames(MENU_ITEM_STYLE)}
                >
                  <div
                    to={URL.FIND_JOBS}
                    className={classNames(KEBAB_LINK, {
                      [ACTIVE_KEBAB_LINK]: activeUrl === URL.FIND_JOBS,
                    })}
                  >
                    {UI.FIND_JOBS}
                  </div>
                </div>
                <div
                  onClick={() => onSelectNavOption(URL.FIND_CANDIDATES)}
                  className={classNames(MENU_ITEM_STYLE)}
                >
                  <div
                    to={URL.FIND_CANDIDATES}
                    className={classNames(KEBAB_LINK, {
                      [ACTIVE_KEBAB_LINK]: activeUrl === URL.FIND_CANDIDATES,
                    })}
                  >
                    {UI.FIND_TALENT}
                  </div>
                </div>
              </Box>
            )}

            {isMobileDevice && (
              <ServicesDropdown
                onSelectNavOption={onSelectNavOption}
                KEBAB_LINK={KEBAB_LINK}
              />
            )}

            <hr className="mt-1 mb-1" />

            <div
              onClick={() => onSelectNavOption(URL.LOGIN)}
              className={classNames(MENU_ITEM_STYLE)}
            >
              <div
                to={URL.LOGIN}
                className={classNames(KEBAB_LINK, {
                  [ACTIVE_KEBAB_LINK]: activeUrl === URL.LOGIN,
                })}
              >
                {UI.LOGIN}
              </div>
            </div>
            <div
              onClick={() => onSelectNavOption(URL.REGISTER)}
              className={classNames(MENU_ITEM_STYLE)}
            >
              <div
                to={URL.REGISTER}
                className={classNames(KEBAB_LINK, {
                  [ACTIVE_KEBAB_LINK]: activeUrl === URL.REGISTER,
                })}
              >
                {UI.REGISTER}
              </div>
            </div>
          </div>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
}

RenderMenu.propTypes = {
  shouldOpen: PropTypes.bool.isRequired,
  setShouldOpen: PropTypes.func.isRequired,
  isMobileDevice: PropTypes.bool.isRequired,
  activeUrl: PropTypes.string.isRequired,
  loggedInUserRole: PropTypes.number,
  handleLogout: PropTypes.func.isRequired,
  onSelectNavOption: PropTypes.func.isRequired,
  hasUpdateJobPermission: PropTypes.bool.isRequired,
  project: PropTypes.string,
  isApprovalPending: PropTypes.bool.isRequired,
  notificationCount: PropTypes.number.isRequired,
  windowWidth: PropTypes.number.isRequired,
};

RenderMenu.defaultProps = {
  loggedInUserRole: undefined,
  project: '',
};

export default RenderMenu;
